import './StudioArtwork.css';
import { PROJECT_COVER_ARTWORKS } from './ProjectCoverMotifs';

const SVG_PROPS = { viewBox: '0 0 360 280', fill: 'none', 'aria-hidden': true, focusable: 'false' };

// Original optical-workbench drawings, not icons. Static geometry is shared across renders.
const PROJECT_ARTWORKS = [
    {
        name: 'reel',
        body: (
            <>
                <path d="M171 151c42 9 25 65 61 69h58v27h-69c-47-2-38-63-65-66Z" fill="var(--color-accent-primary)" opacity=".65" />
                <path d="M173 155c38 13 24 68 62 69h55m-115-53c27 17 22 64 56 67h59" stroke="var(--color-bg-overlay)" strokeWidth="4" strokeDasharray="5 6" />
                <path d="M290 220v27l-8 4v-29Z" fill="var(--color-accent-primary)" />
                <circle cx="149" cy="139" r="82" fill="var(--color-bg-overlay)" stroke="var(--color-text-muted)" strokeOpacity=".35" />
                <circle cx="142" cy="132" r="82" fill="var(--color-bg-tertiary)" stroke="var(--color-text-secondary)" strokeOpacity=".65" />
                <circle cx="142" cy="132" r="73" stroke="var(--color-accent-primary)" strokeWidth="2" />
                <circle cx="142" cy="132" r="67" stroke="var(--color-text-muted)" strokeOpacity=".25" />
                <g fill="var(--color-bg-overlay)" stroke="var(--color-text-muted)" strokeOpacity=".5">
                    <circle cx="142" cy="88" r="19" /><circle cx="184" cy="119" r="19" />
                    <circle cx="168" cy="167" r="19" /><circle cx="116" cy="167" r="19" />
                    <circle cx="100" cy="119" r="19" />
                </g>
                <g fill="var(--color-accent-primary)" opacity=".15">
                    <path d="M126 84a19 19 0 0 1 32 0c-12-7-20-7-32 0M168 115a19 19 0 0 1 32 0c-12-7-20-7-32 0M84 115a19 19 0 0 1 32 0c-12-7-20-7-32 0" />
                </g>
                <circle cx="142" cy="132" r="13" fill="var(--color-accent-primary)" />
                <circle cx="142" cy="132" r="5" fill="var(--color-bg-overlay)" />
                <path d="m139 130 6 4m-6 0 6-4" stroke="var(--color-text-secondary)" />
                <path d="M94 70a77 77 0 0 1 81-5" stroke="var(--color-text-primary)" strokeOpacity=".45" strokeLinecap="round" />
                <path d="M247 226v15m18-15v15" stroke="var(--color-bg-overlay)" strokeOpacity=".6" />
            </>
        ),
        detail: <path d="M239 79h36m-36 6h18M255 101v16m-8-8h16M69 226h22m-16-4v8" stroke="var(--color-accent-secondary)" strokeWidth="1.5" strokeLinecap="round" />,
    },
    {
        name: 'slate',
        body: (
            <g transform="rotate(-8 180 145)">
                <path d="m78 132 8 9h211v94l-8 9H78Z" fill="var(--color-bg-overlay)" stroke="var(--color-text-muted)" strokeOpacity=".4" />
                <rect x="72" y="125" width="217" height="110" rx="5" fill="var(--color-bg-tertiary)" stroke="var(--color-text-secondary)" strokeOpacity=".6" />
                <path d="M72 127h217v20H72Z" fill="var(--color-accent-primary)" />
                <path d="m94 127-14 20m49-20-14 20m49-20-14 20m49-20-14 20m49-20-14 20m49-20-14 20" stroke="var(--color-bg-overlay)" strokeWidth="15" />
                <path d="M87 163h186M87 195h186m-113-32v57m69-57v57" stroke="var(--color-text-muted)" strokeOpacity=".45" />
                <g stroke="var(--color-text-secondary)" strokeLinecap="round">
                    <path d="M90 173h27m-27 7h15m64-7h28m-28 7h16m38-7h22m-22 7h13" strokeOpacity=".5" />
                    <path d="M95 207h36m39 0h12m55 0h15" strokeWidth="3" />
                </g>
                <g transform="rotate(-19 78 124)">
                    <path d="m74 102 8-3h208v22l-7 4H74Z" fill="var(--color-bg-overlay)" stroke="var(--color-text-muted)" strokeOpacity=".45" />
                    <rect x="72" y="99" width="217" height="22" rx="3" fill="var(--color-text-secondary)" />
                    <path d="m96 99-17 22m53-22-17 22m53-22-17 22m53-22-17 22m53-22-17 22m53-22-17 22" stroke="var(--color-bg-overlay)" strokeWidth="15" />
                    <path d="M78 100h204" stroke="var(--color-text-primary)" strokeOpacity=".7" />
                </g>
                <circle cx="79" cy="128" r="8" fill="var(--color-bg-tertiary)" stroke="var(--color-text-secondary)" />
                <circle cx="79" cy="128" r="3" fill="var(--color-accent-primary)" />
                <path d="M273 157v70m-190 0h45" stroke="var(--color-text-primary)" strokeOpacity=".2" />
            </g>
        ),
        detail: <path d="m235 41 9-12m4 23 16-5M57 199H44m7-6v12M264 250h30" stroke="var(--color-accent-secondary)" strokeWidth="1.5" strokeLinecap="round" />,
    },
    {
        name: 'storyboard',
        body: (
            <>
                <g transform="rotate(-12 139 124)">
                    <path d="M60 63h150v136H60Z" fill="var(--color-bg-overlay)" stroke="var(--color-text-muted)" strokeOpacity=".5" />
                    <path d="M67 70h136v89H67Z" fill="var(--color-accent-primary)" opacity=".13" />
                    <path d="m70 143 30-35 26 19 29-32 45 51M73 173h80m-80 8h49" stroke="var(--color-text-muted)" strokeOpacity=".5" />
                    <path d="M63 67h25" stroke="var(--color-accent-secondary)" strokeWidth="2" />
                </g>
                <g transform="rotate(10 229 136)">
                    <path d="M167 72h139v143H167Z" fill="var(--color-bg-secondary)" stroke="var(--color-text-muted)" strokeOpacity=".7" />
                    <path d="M177 83h119v93H177Z" fill="var(--color-bg-overlay)" stroke="var(--color-text-muted)" strokeOpacity=".3" />
                    <circle cx="265" cy="108" r="14" fill="var(--color-accent-primary)" opacity=".55" />
                    <path d="m177 152 35-27 32 39 25-16 27 17v11H177Z" fill="var(--color-text-muted)" opacity=".3" />
                    <path d="M181 189h70m-70 7h41m99-7h9" stroke="var(--color-text-muted)" strokeOpacity=".6" />
                </g>
                <path d="m94 117 9-5h148l8 8v117l-8 7H94Z" fill="var(--color-accent-primary)" opacity=".6" />
                <rect x="89" y="109" width="162" height="127" rx="3" fill="var(--color-bg-tertiary)" stroke="var(--color-text-secondary)" strokeOpacity=".75" />
                <path d="M99 119h142v84H99Z" fill="var(--color-bg-overlay)" />
                <path d="m101 188 39-20 34 7 31-23 34 22v27H101Z" fill="var(--color-accent-primary)" opacity=".28" />
                <path d="m100 197 41-15 35 10 64-8" stroke="var(--color-accent-secondary)" strokeOpacity=".6" />
                <circle cx="178" cy="151" r="5" fill="var(--color-text-secondary)" />
                <path d="m173 159-4 19h6l-2 17h4l3-15 3 15h4l-2-20 2-11-5-5Z" fill="var(--color-text-secondary)" />
                <path d="M105 128v-4h8m114 0h8v4m-130 66v4h8m114 0h8v-4" stroke="var(--color-text-muted)" />
                <path d="M102 215h67m-67 8h36M213 215h25" stroke="var(--color-text-muted)" strokeWidth="1.5" strokeLinecap="round" strokeOpacity=".65" />
                <path d="M180 216h19" stroke="var(--color-accent-primary)" strokeWidth="3" strokeLinecap="round" />
            </>
        ),
        detail: <path d="M68 216H48m10-10v20M243 44h25m-25 6h13M282 236h14l-4-4m4 4-4 4" stroke="var(--color-accent-secondary)" strokeWidth="1.5" strokeLinecap="round" />,
    },
    {
        name: 'spotlight',
        body: (
            <>
                <path d="m160 88 148-40v168l-148-74Z" fill="var(--color-accent-primary)" opacity=".08" />
                <path d="m160 98 132-22v111l-132-56Z" fill="var(--color-accent-secondary)" opacity=".12" />
                <path d="m172 111 116 1m-106-8 96-16m-95 36 102 35" stroke="var(--color-accent-secondary)" strokeOpacity=".22" />
                <path d="M116 151v67m0-36 61 63m-61-63-56 63m56-26-1 30" stroke="var(--color-text-muted)" strokeWidth="6" strokeLinecap="round" />
                <path d="M115 154v59m0-30 60 60m-60-60-53 60" stroke="var(--color-text-secondary)" strokeOpacity=".5" strokeWidth="2" />
                <path d="M78 112v41q0 12 13 12h41q14 0 14-14v-14" stroke="var(--color-text-secondary)" strokeWidth="5" />
                <rect x="104" y="164" width="23" height="18" rx="3" fill="var(--color-bg-tertiary)" stroke="var(--color-text-muted)" />
                <circle cx="130" cy="171" r="5" fill="var(--color-accent-primary)" />
                <g transform="rotate(-12 122 109)">
                    <path d="M63 79h92v67H63q-10-31 0-67Z" fill="var(--color-bg-tertiary)" stroke="var(--color-text-muted)" />
                    <path d="M62 83h65M60 140h67" stroke="var(--color-text-secondary)" strokeOpacity=".6" />
                    <path d="M72 90v41m10-41v41m10-41v41m10-41v41" stroke="var(--color-bg-overlay)" strokeWidth="4" />
                    <ellipse cx="154" cy="112" rx="30" ry="39" fill="var(--color-bg-overlay)" stroke="var(--color-text-secondary)" />
                    <ellipse cx="155" cy="112" rx="23" ry="30" fill="var(--color-accent-primary)" opacity=".8" />
                    <ellipse cx="158" cy="112" rx="16" ry="23" fill="var(--color-accent-secondary)" />
                    <ellipse cx="160" cy="112" rx="8" ry="15" fill="var(--color-accent-contrast)" opacity=".45" />
                    <path d="m137 79 9-34 46 7-23 31m-31 62 9 29 44-5-21-28M178 95l33-6-1 42-31-5" fill="var(--color-bg-secondary)" stroke="var(--color-text-muted)" />
                    <path d="m148 49 33 5m-30 114 29-4m24-67v27" stroke="var(--color-text-secondary)" strokeOpacity=".45" />
                    <circle cx="78" cy="146" r="5" fill="var(--color-accent-primary)" stroke="var(--color-bg-overlay)" strokeWidth="2" />
                </g>
                <path d="M121 182c31 9-9 41 28 51h49" stroke="var(--color-text-muted)" strokeOpacity=".4" strokeWidth="2" />
            </>
        ),
        detail: <path d="M259 54v-8m-4 4h8M281 210h17v-17M60 62H46m7-7v14" stroke="var(--color-accent-secondary)" strokeWidth="1.5" strokeLinecap="round" />,
    },
    {
        name: 'film-loop',
        body: (
            <>
                <path d="M117 225c-47-14-52-50-22-67l132-74c22-12 17-37-13-40 52-7 96 41 46 70l-128 77c-27 17-16 31 10 34Z" fill="var(--color-bg-tertiary)" stroke="var(--color-text-muted)" strokeOpacity=".75" />
                <path d="M219 44c32 6 48 29 19 45l-129 76c-30 18-25 42 17 60" stroke="var(--color-accent-primary)" strokeWidth="3" />
                <path d="M228 52c18 9 22 20 4 31l-128 76c-42 26-18 55 15 61M244 50c26 17 33 39 7 55l-126 76c-26 16-22 28-3 36" stroke="var(--color-text-muted)" strokeWidth="4" strokeDasharray="5 6" />
                <path d="M89 61c38-35 75-15 107 15l71 67c48 46 12 105-47 103-28-1-49-15-59-25 38 13 84-2 73-30-3-9-10-17-20-26L106 72Z" fill="var(--color-accent-primary)" stroke="var(--color-accent-secondary)" />
                <path d="M95 60c31-22 60-5 88 20l76 71c36 34 23 75-15 84m-73-7c38 11 80-6 69-38-4-12-13-23-24-33L111 67" stroke="var(--color-bg-overlay)" strokeWidth="4" strokeDasharray="5 6" />
                <path d="m127 72 24 21-10 13-25-22Zm38 34 25 22-10 13-25-23Zm38 34 24 23-10 13-24-23Zm35 38c7 10 10 20 6 31l13 1c4-11 2-26-9-40Z" fill="var(--color-bg-overlay)" opacity=".66" />
                <path d="m127 72 24 21-10 13m24 0 25 22-10 13m23-1 24 23-10 13" stroke="var(--color-text-secondary)" strokeOpacity=".3" />
                <path d="M89 61c-22 17-8 37 21 50l26-16-29-25Z" fill="var(--color-bg-secondary)" stroke="var(--color-text-muted)" strokeOpacity=".6" />
                <path d="M87 68c-9 12 3 25 24 35" stroke="var(--color-text-secondary)" strokeOpacity=".5" strokeWidth="4" strokeDasharray="4 5" />
                <path d="M244 241c-28 10-61 0-80-17" stroke="var(--color-accent-secondary)" strokeOpacity=".8" />
            </>
        ),
        detail: <path d="M64 133H47m8-8v16M290 107v-15h-15M87 246h25m-25 5h12" stroke="var(--color-accent-secondary)" strokeWidth="1.5" strokeLinecap="round" />,
    },
    {
        name: 'lens',
        body: (
            <>
                {/* Parallel lens planes share a single projection and optical axis. */}
                <ellipse cx="196" cy="136" rx="73.9" ry="88" fill="var(--color-bg-overlay)" stroke="var(--color-text-muted)" strokeOpacity=".65" />
                <path d="M146 60 196 48a73.9 88 0 0 1 0 176l-50 12Z" fill="var(--color-bg-tertiary)" stroke="var(--color-text-muted)" strokeOpacity=".55" />
                <g transform="translate(196 136) scale(.84 1)" stroke="var(--color-text-secondary)" strokeOpacity=".45" strokeWidth="1.5">
                    {[-75, -60, -45, -30, -15, 0, 15, 30, 45, 60, 75].map((angle) => (
                        <path key={angle} d="M81 0h7" transform={`rotate(${angle})`} />
                    ))}
                </g>
                <path d="M178 52a73.9 88 0 0 1 0 176" stroke="var(--color-text-muted)" strokeOpacity=".65" />
                <path d="M163 56a73.9 88 0 0 1 0 176" stroke="var(--color-accent-primary)" strokeWidth="5" />
                {/* Draw the entire front face in one plane so the iris stays concentric. */}
                <g transform="translate(146 148) scale(.84 1)">
                    <circle r="88" fill="var(--color-bg-overlay)" stroke="var(--color-text-secondary)" strokeOpacity=".7" />
                    <circle r="78" fill="var(--color-bg-secondary)" stroke="var(--color-text-muted)" strokeOpacity=".65" />
                    <circle r="70" fill="var(--color-accent-primary)" fillOpacity=".2" stroke="var(--color-text-muted)" strokeOpacity=".3" />
                    <g stroke="var(--color-accent-secondary)" strokeOpacity=".65" strokeWidth="1.2" strokeLinejoin="round">
                        {[0, 60, 120, 180, 240, 300].map((angle, index) => (
                            <path key={angle} transform={`rotate(${angle})`} d="M0-32 57-40a69.6 69.6 0 0 1 6.1 69.4L27.7-16Z" fill="var(--color-accent-primary)" fillOpacity={index % 2 === 0 ? '.12' : '.04'} />
                        ))}
                    </g>
                    <path d="M0-32 27.7-16v32L0 32-27.7 16v-32Z" fill="var(--color-bg-overlay)" stroke="var(--color-accent-secondary)" strokeOpacity=".75" strokeLinejoin="round" />
                    <path d="M-47-46a66 66 0 0 1 35-19M-64-17a66 66 0 0 0-2 17" stroke="var(--color-text-primary)" strokeOpacity=".55" strokeWidth="3.5" strokeLinecap="round" />
                    <path d="M27 60a66 66 0 0 0 35-36" stroke="var(--color-accent-secondary)" strokeOpacity=".5" strokeWidth="2" strokeLinecap="round" />
                    <g stroke="var(--color-text-muted)" strokeOpacity=".65">
                        {[-150, -135, -120, -105, 45, 60, 75].map((angle) => (
                            <path key={angle} d="M82 0h5" transform={`rotate(${angle})`} />
                        ))}
                    </g>
                </g>
                <circle cx="199" cy="65" r="3" fill="var(--color-accent-primary)" />
            </>
        ),
        detail: <path d="M257 54h23v23M70 201H48m11-11v22M254 237h24m-24 5h11" stroke="var(--color-accent-secondary)" strokeWidth="1.5" strokeLinecap="round" />,
    },
];

// Creation keeps its own hand-drawn film gate, separate from project cover motifs.
const CREATE_GATE = (
    <>
        <path d="m59 177 122-66 134 65-123 69Z" fill="var(--color-bg-overlay)" stroke="var(--color-text-muted)" strokeOpacity=".35" />
        <path d="m59 177 133 64 123-65v12l-123 68-133-66Z" fill="var(--color-bg-tertiary)" stroke="var(--color-text-muted)" strokeOpacity=".4" />
        <path d="m75 177 106-56 118 56-107 57Z" stroke="var(--color-accent-primary)" strokeOpacity=".4" />
        <path d="m106 166 75-40 84 40-75 41Z" fill="var(--color-accent-primary)" opacity=".18" />
        <path d="m107 166 74-40 84 40M82 193l25 12m150-4 24-12" stroke="var(--color-accent-secondary)" strokeOpacity=".7" />
        <path d="M92 137v48m189-42v45M188 83v53" stroke="var(--color-text-muted)" strokeDasharray="3 5" strokeOpacity=".4" />
        <path d="m92 102 104-58 89 44v96l-104 59-89-43Z" fill="var(--color-bg-overlay)" stroke="var(--color-text-muted)" strokeOpacity=".7" />
        <path d="m181 146 104-58v96l-104 59Z" fill="var(--color-accent-primary)" opacity=".35" />
        <path d="m92 102 89 44 104-58-89-44Z" fill="var(--color-bg-tertiary)" stroke="var(--color-text-secondary)" strokeOpacity=".55" />
        <path d="m99 108 78 39v84l-78-37Z" fill="var(--color-bg-secondary)" />
        <path d="m196 64 62 30-77 43-62-31Z" fill="var(--color-bg-overlay)" stroke="var(--color-text-muted)" strokeOpacity=".45" />
        <path d="m130 102 64-35 52 26-65 35Z" fill="var(--color-accent-primary)" opacity=".25" />
        <path d="m138 100 55-30 45 22-56 31Z" fill="var(--color-accent-secondary)" opacity=".2" />
        <path d="m181 145 1 91m10-86 83-46" stroke="var(--color-accent-secondary)" strokeOpacity=".6" />
        <g stroke="var(--color-bg-overlay)" strokeWidth="3">
            <path d="m195 160 11-6m-11 17 11-6m-11 17 11-6m-11 17 11-6m-11 17 11-6m-11 17 11-6M262 123l11-6m-11 17 11-6m-11 17 11-6m-11 17 11-6m-11 17 11-6m-11 17 11-6" />
        </g>
        <path d="m217 151 33-18v48l-33 19Z" fill="var(--color-bg-overlay)" stroke="var(--color-accent-secondary)" strokeOpacity=".55" />
        <path d="m223 155 21-12v32l-21 12Z" fill="var(--color-accent-primary)" opacity=".45" />
        <path d="m107 158 21 10v20l-21-10Zm29 14 23 11v19l-23-11Z" fill="var(--color-bg-overlay)" stroke="var(--color-text-muted)" strokeOpacity=".35" />
        <path d="m110 115 50 25m-50-18 28 14" stroke="var(--color-text-secondary)" strokeOpacity=".4" strokeLinecap="round" />
        <path d="m126 103 1 16 54 27 77-43V92" stroke="var(--color-text-muted)" strokeOpacity=".45" />
        <path d="M100 202v9m76 29v8m104-59v8" stroke="var(--color-text-muted)" strokeWidth="5" strokeLinecap="round" />
    </>
);

const CREATE_APERTURE = (
    <>
        <path d="m113 67 76-42 70 34-76 43Z" fill="var(--color-bg-tertiary)" stroke="var(--color-text-secondary)" strokeOpacity=".7" />
        <path d="m113 67 70 35 76-43v8l-76 43-70-35Z" fill="var(--color-accent-primary)" opacity=".75" />
        <path d="m132 67 57-31 51 24-58 32Z" fill="var(--color-bg-overlay)" stroke="var(--color-text-muted)" />
        <path d="m138 67 51-28 45 22-51 28Z" fill="var(--color-accent-primary)" opacity=".28" />
        <path d="m151 68 39-22 31 15-39 22Z" fill="var(--color-accent-secondary)" opacity=".27" />
        <path d="m182 55 16 8-16 9-15-8Z" fill="var(--color-accent-secondary)" />
        <path d="m182 59 8 4-8 4-7-3Z" fill="var(--color-accent-contrast)" opacity=".75" />
        <path d="m124 66 5-3m62-30 5 2m48 25 5 2m-71 35 5 2" stroke="var(--color-text-primary)" strokeOpacity=".55" strokeWidth="2" strokeLinecap="round" />
        <path d="M117 84v16m135-21v17" stroke="var(--color-accent-secondary)" strokeOpacity=".45" strokeDasharray="2 4" />
    </>
);

const CREATE_DETAIL = (
    <>
        <path d="m286 82 13-8m-15-4 6-11M62 118l-13-7m16-5-6-12" stroke="var(--color-accent-secondary)" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M291 222h18m-9-9v18" stroke="var(--color-accent-secondary)" strokeWidth="2" strokeLinecap="round" />
        <path d="m67 229 18 9m-12-12 18 9M65 69h13m-13 5h6" stroke="var(--color-text-muted)" strokeOpacity=".6" />
        <circle cx="54" cy="157" r="3" stroke="var(--color-accent-primary)" /><circle cx="292" cy="126" r="2" fill="var(--color-accent-secondary)" />
    </>
);

function projectArtworkIndex(projectId, artworkCount) {
    const numericId = Number(projectId);
    if (String(projectId).trim() !== '' && Number.isSafeInteger(numericId)) {
        return Math.abs(numericId) % artworkCount;
    }
    // FNV-1a keeps a project's artwork unchanged across filtering, sorting, and reloads.
    let hash = 2166136261;
    for (const character of String(projectId)) {
        hash = Math.imul(hash ^ character.charCodeAt(0), 16777619);
    }
    return (hash >>> 0) % artworkCount;
}

export default function StudioArtwork({ variant = 'cover', projectId, projectName, className = '', includeIdentity = true }) {
    const isCreate = variant === 'create';
    const artworkCollection = variant === 'cover' ? PROJECT_COVER_ARTWORKS : PROJECT_ARTWORKS;
    const artworkIndex = projectId != null ? projectArtworkIndex(projectId, artworkCollection.length) : variant === 'media' ? 5 : 2;
    const artwork = artworkCollection[artworkIndex];
    const projectLabel = projectId == null ? '' : String(projectId);
    const isProjectArtwork = variant === 'cover' || variant === 'media';
    const projectTitle = projectName == null ? '' : String(projectName);
    const showProjectName = isProjectArtwork && projectTitle.trim() !== '';
    const showProjectId = isProjectArtwork && projectLabel.trim() !== '';
    const showIdentity = includeIdentity && (showProjectName || showProjectId);
    const isCompact = variant === 'media';
    const accessibleLabel = [showProjectName ? projectTitle : '', showProjectId ? `项目 ID：${projectLabel}` : ''].filter(Boolean).join('，');
    // Keep the exact ID, including zero and leading zeroes; long IDs wrap rather than truncate.
    const idCharacters = showProjectId ? Array.from(projectLabel) : [];
    const rowLength = idCharacters.length ? Math.ceil(idCharacters.length / Math.ceil(idCharacters.length / 12)) : 1;
    const idRows = [];
    for (let offset = 0; offset < idCharacters.length; offset += rowLength) {
        idRows.push(idCharacters.slice(offset, offset + rowLength).join(''));
    }
    const idFontSize = Math.min(isCompact ? 56 : 40, 480 / rowLength);
    const idStart = showProjectName ? (isCompact ? 360 : 346) : 310;
    const artworkHeight = idStart + idRows.length * idFontSize * 1.1;

    return (
        <span
            className={`studio-artwork studio-artwork--${variant} studio-artwork--${isCreate ? 'film-gate' : artwork.name}${showIdentity ? ' studio-artwork--identified' : ''} ${className}`}
            style={showIdentity ? { aspectRatio: `360 / ${artworkHeight}`, '--studio-artwork-illustration-height': `${280 / artworkHeight * 100}%` } : undefined}
            role={showIdentity ? 'img' : undefined}
            aria-label={showIdentity ? accessibleLabel : undefined}
            aria-hidden={showIdentity ? undefined : 'true'}
        >
            <svg {...SVG_PROPS} className="studio-artwork__base">
                <path d="M51 247h258M68 252h25m185 0h13" stroke="var(--color-text-muted)" strokeOpacity=".15" />
            </svg>
            <span className="studio-artwork__layer studio-artwork__body">
                <svg {...SVG_PROPS}>{isCreate ? CREATE_GATE : artwork.body}</svg>
            </span>
            {isCreate ? (
                <span className="studio-artwork__layer studio-artwork__aperture">
                    <svg {...SVG_PROPS}>{CREATE_APERTURE}</svg>
                </span>
            ) : null}
            <span className="studio-artwork__layer studio-artwork__detail">
                <svg {...SVG_PROPS}>{isCreate ? CREATE_DETAIL : artwork.detail}</svg>
            </span>
            {showIdentity && (
                <svg {...SVG_PROPS} viewBox={`0 0 360 ${artworkHeight}`} className="studio-artwork__identity">
                    {showProjectName && (
                        <foreignObject x="32" y="270" width="296" height={isCompact ? 60 : 42}>
                            <span className="studio-artwork__project-name">{projectTitle}</span>
                        </foreignObject>
                    )}
                    {showProjectId && (
                        <>
                            <text x="180" y={idStart - 23} textAnchor="middle" className="studio-artwork__id-label">项目 ID</text>
                            {idRows.map((row, index) => (
                                <text key={index} x="180" y={idStart + idFontSize * (0.85 + index * 1.1)} textAnchor="middle" fontSize={idFontSize} className="studio-artwork__id-number">{row}</text>
                            ))}
                        </>
                    )}
                </svg>
            )}
        </span>
    );
}
